import "@mdi/font/css/materialdesignicons.css"; // Ensure you are using css-loader
import Vue from "vue";
import Vuetify from "vuetify/lib";
//import "vuetify/src/stylus/app.styl";
//import "@/plugins/main.sass";

Vue.use(Vuetify);

const opts = {
  theme: {
    themes: {
      light: {
        primary: '#5fc5ae',
        secondary: '#2A7DE1',
        accent: '#8c9eff',
        error: '#b71c1c',
      },
    },
  },
  icons: {
    iconfont: "mdi" // default - only for display purposes
  }
};

export default new Vuetify(opts);
